import React, { useEffect } from "react";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { BrowserRouter, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import Snackbar from "./components/Snackbar/Snackbar";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [pathname, search]);

  return null;
};

const AppContent = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
};

function App() {
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Mark that a reload might be happening
      sessionStorage.setItem("isReloading", "true");
    };

    const handleLoad = () => {
      const isReloading = sessionStorage.getItem("isReloading");

      if (!isReloading) {
        // This means it's a fresh tab close (not reload)
        const keysToRemove = [
          "fitbit_access_token",
          "fitbit_refresh_token",
          "fitbit_expiry",
          "fitbit_login_time",
          "fitbit_last_refresh",
        ];

        keysToRemove.forEach((key) => {
          localStorage.removeItem(key);
        });
      }

      // Clear the flag after load
      sessionStorage.removeItem("isReloading");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("load", handleLoad);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  return (
    <div className="App">
      <Provider store={store}>
        <Snackbar />
        <AppContent />
      </Provider>
    </div>
  );
}

export default App;
